/* 🤖 this file was generated by svg-to-ts */
export const DfIconHome16: {
  name: 'home-16';
  data: string;
} = {
  name: 'home-16',
  data: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M9.119 15.595v7.188a.72.72 0 0 1-.719.719H4.101a.72.72 0 0 1-.719-.719v-9.344H1.219a.72.72 0 0 1-.526-1.21L11.483.726a.72.72 0 0 1 1.018-.033l10.807 11.536a.72.72 0 0 1-.525 1.211h-2.162v9.339a.72.72 0 0 1-.719.719h-4.309a.72.72 0 0 1-.72-.719v-7.185a.72.72 0 0 0-.719-.719H9.841a.72.72 0 0 0-.719.719z"/></svg>`
};
